@import 'fluid-label.theme.less';

// ================================================================ //
// -- Theme Definition

:host {

  .fluid-label {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @label-tokens: @label-tokens-legacy;
      @label();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @label-tokens: @label-tokens-lm;
      @label();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @label-tokens: @label-tokens-corp;
      @label();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @label-tokens: @label-tokens-portal;
      @label();
    }
  }

}


// ================================================================ //
// -- Component Detached Ruleset

@label: {
  font-family: @font-family;
  font-size: @font-size;
  color: @color-text;
  display: block;

  &.muted {
    font-size: @label-tokens[@muted][font-size];
    color: @label-tokens[@muted][color];
  }

  &.inline {
    display: inline-block;
  }
}
